import { CheckboxInput, IfFormData } from "ui-builder";
import { ProjectDetailsFieldType } from "nekst-api";
import { Separator } from "features/nekst-widgets";
import React from "react";
import { ManageCommissionAndClosingDateWrapper } from "feature-toggle";

export function IsCommissionFieldInput() {
  return (
    <ManageCommissionAndClosingDateWrapper>
      <IfFormData<{ fieldType: ProjectDetailsFieldType }>
        conditionFunc={(data) => data.fieldType === ProjectDetailsFieldType.PRICE}>
        <Separator />
        <CheckboxInput source="isCommissionField" label="Use this box for commission calculation" />
      </IfFormData>
    </ManageCommissionAndClosingDateWrapper>
  );
}
